
<style lang='scss'>
</style>

<template>
  <Row class="padding-right-20 lookitem">
    <Col span='12'>
    <span class="item-label">店铺：</span>
    <span class="item-content">{{formData.accountFlag}}</span>
    </Col>
    <Col span='12'>
    <span class="item-label">Seller SKU：</span>
    <span class="item-content">{{formData.sellerSku}}</span>
    </Col>
    <Col span='12'>
    <span class="item-label">项目：</span>
    <span class="item-content">{{formData.lineId|transferText('name',products)}}</span>
    </Col>
    <Col span='12'>
    <span class="item-label">ERPSKU：</span>
    <span class="item-content">{{formData.erpSku}}</span>
    </Col>
    <Col span='12'>
    <span class="item-label">锁定开始时间：</span>
    <span class="item-content">{{formData.beginDate}}</span>
    </Col>
    <Col span='12'>
    <span class="item-label">锁定结束时间：</span>
    <span class="item-content">{{formData.endDate}}</span>
    </Col>
    <Col span='12'>
    <span class="item-label">锁定仓库：</span>
    <span class="item-content">{{formData.orgWarehouseId|transferText('code',warehouses)}}</span>
    </Col>
    <Col span='12'>
    <span class="item-label">锁定数量：</span>
    <span class="item-content">{{formData.quantity}}</span>
    </Col>
    <Col span='12'>
    <span class="item-label">状态：</span>
    <span class="item-content">{{formData.status|transferText('label',statusData,'value')}}</span>
    </Col>
    <Col span='12'>
    <span class="item-label">锁定原因：</span>
    <span class="item-content">{{formData.reasonType|transferText('label',reasonType,'value')}}</span>
    </Col>
    <Col span='24'>
    <span class="item-label">备注：</span>
    <span class="item-content width-80per">
      {{formData.remark}}
    </span>
    <Spin size="large"
          fix
          v-if="loading"></Spin>
    </Col>
  </Row>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { HttpUpdateSaLock, HttpSaLock } from '@/service/boss/allot';
export default {
  props: ['id'],
  data () {
    return {
      loading: false,
      reasonType: [{
        value: 2,
        label: "超期备货"
      }, {
        value: 1,
        label: "新品锁定"
      }, {
        value: 3,
        label: "爆款备货"
      }, {
        value: 4,
        label: "促销锁定"
      }, {
        value: 5,
        label: "其它"
      }],
      statusData: [{
        value: ' DRAFT',
        label: "草稿"
      }, {
        value: 'ACTIVATE',
        label: "激活"
      }, {
        value: 'CANCEL',
        label: "取消"
      }],
      formData: {
        accountId: '',
        lineId: '',
        sellerSku: '',
        erpSku: '',
        beginDate: '',
        endDate: '',
        orgWarehouseId: '',
        remark: '',
        status: 'ACTIVATE',
        reasonType: '',
        quantity: 0,
      },

    };
  },
  mounted () {
    this.getDetail();
  },
  filters: {
    transferText (val, textKey, list = [], key = "id") {
      let text = "";
      list.forEach(item => {
        if (item[key] === val) {
          text = item[textKey]
        }
      });
      return text;
    }
  },
  computed: {
    ...mapState('boss', ['products', 'accounts']),
    ...mapGetters('boss', ['warehouses']),
  },
  methods: {
    cancel () {
      this.emit('on-close')
    },
    async getDetail () {
      this.loading = true;
      HttpSaLock({
        id: this.id
      }).then(res => {
        this.formData = res.data;
        this.loading = false;
      }, err => {
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
        this.loading = false;
      })
    }
  },

};
</script>



